import { DataRoomFile } from '@/types/documents/documents.types';

/**
 * Filters documents by collection ID
 */
export const filterDocumentsByCollection = (
  documents: DataRoomFile[],
  collectionId: string | null
): DataRoomFile[] => {
  if (!collectionId) {
    return documents;
  }

  return documents.filter((doc) => {
    // Check if document has a collectionId field that matches
    // Support both collectionId and dataRoomCollectionId field names
    const docCollectionId =
      doc.collectionId ||
      doc.dataRoomCollectionId ||
      (doc as DataRoomFile & { collectionId?: string }).collectionId ||
      (doc as DataRoomFile & { dataRoomCollectionId?: string }).dataRoomCollectionId;
    return docCollectionId === collectionId;
  });
};

/**
 * Gets documents that belong to a specific collection
 */
export const getDocumentsInCollection = (
  documents: DataRoomFile[],
  collectionId: string
): DataRoomFile[] => {
  return filterDocumentsByCollection(documents, collectionId);
};

/**
 * Gets documents that don't belong to any collection
 */
export const getUnassignedDocuments = (
  documents: DataRoomFile[]
): DataRoomFile[] => {
  return documents.filter((doc) => {
    const docCollectionId =
      (doc as DataRoomFile & { collectionId?: string }).collectionId ||
      (doc as DataRoomFile & { dataRoomCollectionId?: string }).dataRoomCollectionId;
    return !docCollectionId;
  });
};
